var klaviyo = klaviyo || [];
    klaviyo.init({
      account: "Rx7dRj",
      list: "QQ4aVE",
      platform: "shopify"
    });
    klaviyo.enable("backinstock",{ 
    trigger: {
      product_page_text: "DE - Notify Me When Available",
      product_page_class: "btn",
      product_page_text_align: "center",
      product_page_margin: "0px",
      replace_anchor: false
    },
    modal: {
     headline: "{product_name}",
     body_content: "Skriv deg opp for å motta beskjed hvis varen er på lager igjen.",
     email_field_label: "E-mail",
     button_label: "Gi meg beskjed",
     subscription_success_label: "Mottatt. Forhåpentligvis hører du snart fra oss.",
     newsletter_subscribe_label: "Legg meg til på e-postlisten.",
     subscribe_checked: true,
     footer_content: '',
     additional_styles: "@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans');",
     drop_background_color: "#000",
     background_color: "#fff",
     text_color: "#222",
     button_text_color: "#fff",
     button_background_color: "#439fdb",
     close_button_color: "#ccc",
     error_background_color: "#fcd6d7",
     error_text_color: "#C72E2F",
     success_background_color: "#d3efcd",
     success_text_color: "#1B9500",
     close_label: "Lukk" 
    }
  });